import React from 'react';
import {FormattedMessage} from 'react-intl';
import {format, parseISO} from 'date-fns';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {useUserSessionContext} from '../../../../common/components/core/UserSessionContext';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import BasicDetails from '../BasicDetails';
import Calculation from '../Calculation';
import {TransferRowExtended} from '../TransfersContext';
import {SystemSocialParams} from '../../../../common/types';
import styles from './DetailsPanel.module.scss';

export interface DetailsPanelProps extends TransferRowExtended {
  systemSocialParams: SystemSocialParams;
}

const DetailsPanel = ({...row}: DetailsPanelProps) => {
  const {setPopupPanelContent, closePopupPanel} = useGlobalContext();
  const {currentUser} = useUserSessionContext();

  const handleClose = () => {
    closePopupPanel();
    setPopupPanelContent(null);
  };

  const date = Boolean(row.datetime)
    ? format(parseISO(row.datetime), 'dd/MM/yyyy')
    : '';

  return (
    <div className={styles.panelContainer}>
      <div className={styles.content}>
        <div className={styles.title}>
          <FormattedMessage
            id={'transfers-popup-details-title'}
            defaultMessage={'Transfer to agent'}
          />
        </div>
        <div className={styles.subTitle}>
          <FormattedMessage
            id={'transfers-popup-details-subtitleName'}
            defaultMessage={'{firstName} {lastName} - {id}'}
            values={{
              firstName: currentUser?.profile?.firstName,
              lastName: currentUser?.profile?.lastName,
              id: currentUser?.agentId,
            }}
          />
        </div>
        <div className={styles.subTitle}>
          <FormattedMessage
            id={'transfers-popup-details-subtitleDate'}
            defaultMessage={'(salary {period}) {date}'}
            values={{
              period: [row.paycheck?.date?.month, row.paycheck?.date?.year].filter(Boolean).join('.'),
              date,
            }}
          />
        </div>
        <div className={styles.details}>
          <div className={styles.receipts}>
            <BasicDetails
              vatIncludedLineIds={row?.vatIncludedLineIds}
              lines={row?.lines}
              customLines={row?.customLines}
              vatIncludedCustomLines={row?.vatIncludedCustomLines}
            />
          </div>
          <div className={styles.summary}>
            {row?.calculation && (
              <Calculation
                {...row?.calculation}
                commissionPercents={row?.socialParams.commission}
                pensionManagementCommission={row?.socialParams.pensionManagementCommission}
                paycheck={row?.paycheck}
                lastPaycheck={row?.lastPaycheck}
              />
            )}
          </div>
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <ButtonAction
          label={(
            <FormattedMessage
              id={'transfers-popup-details-calculation-closeBtn'}
              defaultMessage={'Close'}
            />
          )}
          onClick={handleClose}
          customClassnames={{
            container: styles.closeButtonContainer,
            label: styles.closeButtonLabel
          }}
        />
      </div>
    </div>
  );
};

export default DetailsPanel;
